import React, { Component, Fragment } from 'react';
import { Icon, Input, Popover } from 'antd';

import './Registrations.css';

import { Flex, Box } from 'reflexbox';
import { observer, inject } from 'mobx-react';
import { reaction } from 'mobx';
import PendingRegistration from './PendingRegistration';
import RegistrationsHeader from './RegistrationsHeader';

import { Link } from 'react-router-dom';

@inject('usersStore', 'translationsStore', 'registrationStore', 'profileStore')
@observer
export default class Registrations extends Component {
  constructor(props) {
    super(props);
    this.defaultDataSourceQuery = '';
    this.state = {
      loading: false,
      dataSource: [],
      dataSourceIsFiltered: false,
      dataSourceQuery: this.defaultDataSourceQuery,
      dataSourceFiltered: []
    };
    reaction(
      () => this.props.usersStore.pendingFiltered,
      fn => {
        this.setState({dataSourceFiltered : fn});
      }
    );
  }

  componentDidMount() {
    const { usersStore } = this.props;
    this.setState({ loading: true });
    this.props.usersStore.setPendingFileter(this.state.dataSourceQuery);
    usersStore.load();
  }

  handleNewRegistrationClick = () => this.props.registrationStore.reset();

  onQueryChange = e => {
    const { value } = e.target;
    this.handleQueryUpdate(value);
  };

  handleQueryUpdate = newValue => {
    this.props.usersStore.setPendingFileter(newValue);
    this.setState({ dataSourceIsFiltered: newValue !== this.defaultDataSourceQuery, dataSourceQuery: newValue });
  };

  handleQueryReset = () => {
    this.props.usersStore.setPendingFileter('');
    this.setState({ dataSourceIsFiltered: false, dataSourceQuery: ''});
  };

  render() {
    const { translationsStore } = this.props;
    const { current: t } = translationsStore;
    const { dataSourceIsFiltered, dataSourceQuery, dataSourceFiltered } = this.state;

    return (
      <Flex column align={'stretch'} pl={30} pr={30} className="Registrations">
        <Flex justify={'center'} align={'center'}>
          <Link to="/registration" onClick={this.handleNewRegistrationClick} className="btnNewRegistration">
            {t['pendingList']['btnNewRegistration']}
          </Link>
        </Flex>
        <Flex justify={'center'} align={'center'}>
          <div className="lblTableTitle">{t['pendingList']['lblCurrentRegistrations']}</div>
        </Flex>
        <Flex justify={'center'} align={'center'}>
          <Popover content={t['shared']['lblFilterQueryLongHint']} placement="bottom">
            <Input
              className="lblFilterQuery"
              type="text"
              placeholder={t['shared']['lblFilterQueryHint']}
              value={dataSourceQuery}
              onChange={this.onQueryChange}
              suffix={dataSourceIsFiltered ? <Icon type="close-circle" style={{ cursor: 'pointer', color: 'rgba(0,0,0,.45)' }} onClick={this.handleQueryReset} /> : <Fragment />}
            />
          </Popover>
        </Flex>
        <Flex column>
          <RegistrationsHeader />
          <Box>
            {dataSourceFiltered.map(user => (
              <PendingRegistration user={user} key={user._id} />
            ))}
          </Box>
        </Flex>
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Registrations/Registrations.js